class InputValConverter {
  isComposing = false;
  constructor() {
    this.DOM = {
      inputs: document.querySelectorAll('[data-form-convert]'),
    };
    this.#addEvent();
  }
  #addEvent() {
    if (this.DOM.inputs.length === 0) return;
    for (const input of this.DOM.inputs) {
      input.addEventListener('compositionstart', () => {
        this.isComposing = true;
      });
      input.addEventListener('compositionend', () => {
        this.#restoreCaretPos(input);
        this.isComposing = false;
      });
      input.addEventListener('input', () => {
        if (this.isComposing) return;
        this.#restoreCaretPos(input);
      });
    }
  }
  #restoreCaretPos(input) {
    const inputVal = input.value;
    const sanitizedVal = this.#sanitizeInput(inputVal, input.dataset.allowedCharacters);
    const convertedVal = this.#convertToHalfWidth(sanitizedVal);
    // .setSelectionRange は以下のインプットタイプにしか使用できないため、それ以外の場合は適用しない
    const applicableTypes = ['text', 'search', 'URL', 'tel', 'password'];
    if (applicableTypes.includes(input.getAttribute('type'))) {
      const startCaretPos = input.selectionStart;
      const endCaretPos = input.selectionEnd;
      input.value = convertedVal;
      input.setSelectionRange(startCaretPos, endCaretPos);
    } else {
      input.value = convertedVal;
    }
  }
  #sanitizeInput(inputVal, allowedCharacters) {
    const sanitizedVal = inputVal.replace(new RegExp(`[^${allowedCharacters}]`, 'ig'), '');
    console.log(inputVal)
    console.log(sanitizedVal)
    if (inputVal !== sanitizedVal) {
      inputVal = sanitizedVal;
    }
    return inputVal;
  }
  #convertToHalfWidth(inputVal) {
    let convertedVal = '';
    for (let i = 0; i < inputVal.length; i++) {
      const char = inputVal.charAt(i);
      const charCode = char.charCodeAt(0);
      if (charCode >= 65281 && charCode <= 65374) {
        convertedVal += String.fromCharCode(charCode - 65248);
      } else {
        convertedVal += char;
      }
    }
    return convertedVal;
  }
}
export default InputValConverter;